import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IHolidayDetail} from '../../interfaces/iholiday-detail';
import Swiper, {SwiperOptions} from "swiper";
import { IHolidayDetailSolution } from '../../interfaces/iholiday-detail-solution';
import { CmsService } from 'src/app/modules/cms/services/cms.service';
import {Subscription} from 'rxjs';
import {WidgetService} from '../../../../../shared/services/widget.service';
import {PostMessageService} from '../../../../../shared/services/post-message.service';

@Component({
  selector: 'app-detail-content-accomodation-tabs',
  templateUrl: './detail-content-accomodation-tabs.component.html',
  styleUrls: ['./detail-content-accomodation-tabs.component.scss']
})
export class DetailContentAccomodationTabsComponent implements OnInit, OnDestroy {

  @Input() holidayDetails: IHolidayDetail;
  @Input() selectedSolution: IHolidayDetailSolution;

  public brand: any;
  public selectedSectionId: string;

  config: SwiperOptions = {
    breakpoints: {
      320: {
        slidesPerView: 2,
        allowTouchMove: true
      },
      425: {
        slidesPerView: 3,
        allowTouchMove: true
      },
      768: {
        slidesPerView: 4,
        allowTouchMove: true
      },
      992: {
        slidesPerView: 6,
        allowTouchMove: true
      },
      1200: {
        slidesPerView: 8,
        allowTouchMove: false
      }
    },
    centeredSlides: false,
    allowSlideNext: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  index;
  
  private isWidget: boolean;
  
  private isWidgetSubscription: Subscription;
  private brandConfigSubscription: Subscription;

  constructor(
    private _cmsService: CmsService,
    private _widgetService: WidgetService,
    private _postMessageService: PostMessageService
  ) { }

  ngOnInit(): void {
    this.brandConfigSubscription = this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) {
        this.brand = brand;
      }

      // di default, se presente la griglia partenze, evidenzio con un active la relativa tab associata altrimenti, evidenzio la tab del dettaglio
      this.selectedSectionId = (this.brand?.detailPageConfig?.showPriceGrid) ? 'solutions' : 'details';
    });
    this.isWidgetSubscription = this._widgetService.isWidget().subscribe((isWidget) => {
      this.isWidget = isWidget;
    });
  }

  selectTab(id): void {
    const fixedNavBreakpoint = 992;
    const targetElementPosition = document.querySelector(`.accomodation-tab__${id}`)?.getBoundingClientRect();
    if (!targetElementPosition) return;

    //  Se il menu delle tab è fisso aggiunge come offset per lo scroll la sua altezza per evitare che si sovrapponga al contenuto
    const offset = (window.innerWidth > fixedNavBreakpoint) ? (document.querySelector(`.detail-tabs__container`)?.getBoundingClientRect()?.height || 0) : 0;
    const positionToScroll = (targetElementPosition.top + window.pageYOffset) - offset;

    // verifico se si tratta di un widget o di un sito in modo da effettuare correttamente lo scroll
    if (this.isWidget) {
      this._postMessageService.scrollToElementPos(positionToScroll);
    } else {
      window.scrollTo({top: positionToScroll, behavior: 'smooth'}); 
    }

    // salvo l'id della sezione nella proprietà dedicata in modo da visualizzare l'active nel relativo tab
    this.selectedSectionId = id;
  }
  
  ngOnDestroy() {
    this.brandConfigSubscription?.unsubscribe();
    this.isWidgetSubscription?.unsubscribe();
  }

}
